//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import chunk from "lodash/chunk"
import { gsap } from 'gsap'
import { datesToHuman } from "../../../utils/dates.js";
import EventDetailCard from "@/components/objects/public/object-snippets/Event.vue";
import { colorToTransparantize } from "@/utils/helpers.js";
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: "EventsDetail",
  components: { EventDetailCard },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    itemsList: {
      type: Array,
      default: () => {
        return []
      }
    },
    colors: {
      type: Array,
      default: () => {
        return []
      }
    },
    useStorage: {
      type: Boolean
    },
    template: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    },
    listInfo: {
      type: Object,
    },
    domId: {
      type: String,
      default: ''
    },
    detail: {
      type: Boolean,
    },
    design: {
      type: String,
      default: () => 'default'
    },
    theme: {
      type: String,
      default: () => 'default'
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
  },
  data() {
    return {
      calcedLineHeight: 0,
      scrollObserver: null,
      animatedItems: null,
      centralTimelineAnimated: false,
    }
  },
  watch: {
    'itemsList.length'() {
      this.$nextTick(() => {
        this.updateCalcedLineHeight()
        this.setupScrollAnimations()
      })
    },
  },
  computed: {
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled) {
        return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      } else if (this.design_extra?.first_block?.gradient_enabled && this.design_extra?.first_block?.bg_color) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      }

      return this.getFirstBlockBgColor;
    },
    getFirstBlockBgColor() {
      return this.design_extra?.first_block?.bg_color ?? this.getBgColor(0) ?? null;
    },
    getFirstBlockBgGradientEnabled() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_enabled ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_enabled ?? null;
      }
    },
    getFirstBlockBgGradientDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_direction ?? null;
      }
    },
    getFirstBlockBgGradientShadowDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_shadow_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
      }
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    },
    chunks() {
      return chunk(this.itemsList.map(({ ...item }, index) => {
        item.index = index
        if (item.loader) return item

        item.target_object.text = item.text || item.target_object.text

        return item
      }), 2)
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.addEventListener('vistat:prepare-export', this.finishScrollAnimationsForExport)
      this.$nextTick(() => {
        this.updateCalcedLineHeight()
        this.setupScrollAnimations()
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.updateCalcedLineHeight()
    })
  },
  destroyed() {
    window.removeEventListener('vistat:prepare-export', this.finishScrollAnimationsForExport)
    this.teardownScrollAnimations()
  },
  methods: {
    isScrollExportTarget(event) {
      const element = event?.detail?.element
      return !!(element && this.$el && (this.$el === element || this.$el.contains(element) || element.contains(this.$el)))
    },
    finishScrollAnimationsForExport(event) {
      if (!this.isScrollExportTarget(event)) return

      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
        this.scrollObserver = null
      }
      this.stopAllTweens()
      const animatedTargets = [
        this.$refs['central-timeline'],
        ...this.$el.querySelectorAll('.events-list__indicator .event__calendar, .events-list__indicator .events-list__title, .event__arrow, .event-head, .event__body, .event--loader'),
      ].filter(Boolean)
      gsap.killTweensOf(animatedTargets)
      gsap.set(animatedTargets, { clearProps: 'transform,opacity' })
      this.centralTimelineAnimated = true
      this.animatedItems = new WeakSet()
      this.$nextTick(this.updateCalcedLineHeight)
    },
    addTween(tween) {
      if (!this._activeGsapTweens) this._activeGsapTweens = new Set()
      if (!tween) return tween
      this._activeGsapTweens.add(tween)
      tween.eventCallback('onComplete', () => this._activeGsapTweens.delete(tween))
      return tween
    },
    stopAllTweens() {
      if (!this._activeGsapTweens) return
      this._activeGsapTweens.forEach((tween) => tween.kill())
      this._activeGsapTweens.clear()
    },
    teardownScrollAnimations() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
        this.scrollObserver = null
      }
      this.stopAllTweens()
      this.animatedItems = null
      this.centralTimelineAnimated = false
    },
    isScrollAnimationEnabled() {
      if (typeof window === 'undefined') return false
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    },
    clearGsapInlineStyles(elements, props = 'transform') {
      elements.filter(Boolean).forEach((el) => gsap.set(el, { clearProps: props }))
    },
    setupScrollAnimations() {
      if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return
      if (!this.$refs['timeline-items']) return

      if (!this.animatedItems) {
        this.animatedItems = new WeakSet()
      }

      if (!this.isScrollAnimationEnabled()) return

      if (!this.scrollObserver) {
        this.scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            this.animateScrollTarget(entry.target)
            this.scrollObserver.unobserve(entry.target)
          })
        }, {
          threshold: 0.12,
          rootMargin: '60px 0px',
        })
      }

      this.$refs['timeline-items'].querySelectorAll('[data-scroll-item]').forEach((item) => {
        if (this.animatedItems.has(item)) return
        this.prepareScrollTarget(item)
        this.scrollObserver.observe(item)
      })
    },
    prepareScrollTarget(target) {
      if (target.dataset.scrollItem === 'indicator') {
        this.prepareIndicator(target)
        return
      }

      if (target.dataset.scrollItem === 'line') {
        this.prepareLine(target)
      }
    },
    animateScrollTarget(target) {
      if (this.animatedItems?.has(target)) return
      this.animatedItems.add(target)

      if (target.dataset.scrollItem === 'indicator') {
        this.animateIndicator(target)
        this.animateCentralTimeline()
        return
      }

      if (target.dataset.scrollItem === 'line') {
        this.animateLine(target)
        this.animateCentralTimeline()
      }
    },
    prepareIndicator(indicator) {
      const parts = [
        indicator.querySelector('.event__calendar'),
        indicator.querySelector('.events-list__title'),
      ].filter(Boolean)

      gsap.set(parts, { opacity: 0, y: 10, scale: 0.94 })

      const arrow = indicator.querySelector('.event__arrow')
      if (arrow) {
        this.prepareArrow(arrow)
      }
    },
    animateIndicator(indicator) {
      const parts = [
        indicator.querySelector('.event__calendar'),
        indicator.querySelector('.events-list__title'),
      ].filter(Boolean)
      const arrow = indicator.querySelector('.event__arrow')
      const timeline = gsap.timeline()

      timeline.to(parts, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.48,
        stagger: 0.06,
        ease: 'back.out(1.35)',
        onComplete: () => this.clearGsapInlineStyles(parts),
      }, 0)

      this.animateArrow(timeline, arrow, 0.55)

      this.addTween(timeline)
    },
    getLineCards(line) {
      return line.querySelectorAll('.event-item, .event--loader')
    },
    prepareLine(line) {
      this.getLineCards(line).forEach((card, index) => {
        if (card.classList.contains('event--loader')) {
          gsap.set(card, { opacity: 0 })
          return
        }

        const head = card.querySelector('.event-head')
        const body = card.querySelector('.event__body')
        if (head) {
          gsap.set(head, { opacity: 0, y: 12, scale: 0.96 })
        }
        if (body) {
          gsap.set(body, { opacity: 0 })
        }
        this.prepareArrow(card.querySelector('.event__arrow'))
      })
    },
    prepareArrow(arrow) {
      if (!arrow) return
      gsap.set(arrow, { opacity: 0 })
    },
    animateArrow(timeline, arrow, position) {
      if (!arrow) return

      timeline.to(arrow, {
        opacity: 1,
        duration: 0.42,
        ease: 'power2.out',
        onComplete: () => gsap.set(arrow, { clearProps: 'opacity' }),
      }, position)
    },
    animateLine(line) {
      const cards = this.getLineCards(line)
      const timeline = gsap.timeline()

      cards.forEach((card, index) => {
        const delay = index * 0.1

        if (card.classList.contains('event--loader')) {
          timeline.to(card, {
            opacity: 1,
            duration: 0.42,
            ease: 'power2.out',
            onComplete: () => gsap.set(card, { clearProps: 'opacity' }),
          }, delay)
          return
        }

        const head = card.querySelector('.event-head')
        const body = card.querySelector('.event__body')

        if (head) {
          timeline.to(head, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.48,
            ease: 'back.out(1.35)',
            onComplete: () => this.clearGsapInlineStyles([head]),
          }, delay)
        }

        if (body) {
          timeline.to(body, {
            opacity: 1,
            duration: 0.36,
            ease: 'power2.out',
            onComplete: () => gsap.set(body, { clearProps: 'opacity' }),
          }, delay + 0.05)
        }

        this.animateArrow(timeline, card.querySelector('.event__arrow'), delay + 0.5)
      })

      this.addTween(timeline)
    },
    animateCentralTimeline() {
      if (this.centralTimelineAnimated) return

      const timelineEl = this.$refs['central-timeline']
      if (!timelineEl || timelineEl.offsetParent === null) return

      this.centralTimelineAnimated = true
      gsap.set(timelineEl, { scaleY: 0, transformOrigin: 'top center' })
      this.addTween(gsap.to(timelineEl, {
        scaleY: 1,
        duration: 0.85,
        ease: 'power2.out',
        onComplete: () => gsap.set(timelineEl, { clearProps: 'transform' }),
      }))
    },
    getBgColor(index) {
      if (this.bgPalette) {
        return [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color
      }

      return null;
    },
    updateCalcedLineHeight() {
      const block = this.$refs['timeline-items'];
      if (block) {
        const lastElement = block.querySelector('.events-list__line:last-child');
        if (lastElement) {
          this.calcedLineHeight = (block.clientHeight - (parseFloat(window.getComputedStyle(lastElement).marginTop) / 2) + 1 - lastElement.clientHeight / 2) - 30;
        }
      }
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        return colorToTransparantize([this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors][index % [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors].length], 0.5);
      } else if (this.design_extra?.icon_border?.color) {
        return colorToTransparantize(this.design_extra.icon_border.color, 0.5);
      }

      return null;
    },
    getDescription(text) {
      return text.replace(/<\/?[^>]+(>|$)/g, "")
    },
    getDates(event_date) {
      return datesToHuman({
        value: event_date.vfrom,
      }, {
        value: event_date.vto
      })
    },
  }
}
